import { selectorFamily } from 'recoil';
import { PassingsService } from 'api';
const getCustomerHasArchivedPassings = selectorFamily({
  key: 'getCustomerHasArchivedPassings',
  get: customerId => async () => {
    if (!customerId) return false;
    try {
      return await PassingsService.customerHasArchivedPassings({
        customerId
      });
    } catch (e) {
      console.error(e);
    }
    return false;
  }
});
export default getCustomerHasArchivedPassings;